// extracted by mini-css-extract-plugin
module.exports = {"activeModal":"styles_activeModal__2S0MI","iconContainer":"styles_iconContainer__2wX4w","content":"styles_content__2WMHs"};